import Axios from 'axios'
import qs from 'qs'
import { Message } from 'iview'
import config from '../../config'
import { getToken, clearToken } from '../utils'
import store from '@/store'
import { storage } from '../tools'

const addErrorLog = errorInfo => {
  const { statusText, status, request: { responseURL } } = errorInfo
  let info = {
    type: 'ajax',
    code: status,
    mes: statusText,
    url: responseURL
  }
  // if (!responseURL.includes('save_error_logger'))
  store.dispatch('addErrorLog', info)
}

class Http {
  constructor (options) {
    this.options = options
    this.queue = {}
  }

  destroy (url) {
    delete this.queue[url]
    if (!Object.keys(this.queue).length) {
      // Spin.hide()
    }
  }

  getConfig () {
    return Object.assign({}, this.options, {})
  }

  interceptors (instance) {
    const url = this.options.baseURL
    // request
    instance.interceptors.request.use(config => {
      this.queue[url] = true
      if (!config.url.includes('/login')) {
        config.headers['Token'] = getToken()
      }
      return config
    }, error => {
      return Promise.reject(error)
    })
    // response
    instance.interceptors.response.use(res => {
      this.destroy(url)
      const { status, data: { data, code, msg, succ } } = res
      if (status !== 200) {
        Message.error('连接服务器失败!')
        return {}
      } else {
        if (code === 'SS0002') {
          clearToken()
          storage.clearAll()
          window.location.href = '/Login'
        }
        if (code !== 'S00000') {
          Message.destroy()
          Message.error(msg)
          let errorInfo = {
            statusText: msg,
            status: code,
            request: { responseURL: res.config.url }
          }
          addErrorLog(errorInfo)
        }
      }
      return { data, succ, code, msg }
    }, error => {
      this.destroy(url)
      let errorInfo = error.response
      if (!errorInfo) {
        let errObj = JSON.parse(JSON.stringify(error))
        let config, statusText, status
        try {
          config = errObj.config
          statusText = errObj.request.statusText
          status = errObj.request.status
        } catch (e) {
          config = errObj.config
          statusText = errObj.message
          status = 404
        }
        errorInfo = {
          statusText,
          status,
          request: { responseURL: config.url }
        }
      }
      Message.error('链接服务器发生异常，请检查网络是否正常!')
      addErrorLog(errorInfo)
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = Axios.create()
    options = Object.assign(this.getConfig(), options)
    options = this.isGet(options)
    this.interceptors(instance)
    return instance(options)
  }

  isGet (options) {
    if (options.method === 'get') {
      options.url = `${options.url}?${qs.stringify(options.data)}`
      delete options.data
    }
    return options
  }
}

const http = new Http(config.HTTP_CONFIG)
export default http
